import { HttpClient } from '@angular/common/http';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable, of } from 'rxjs';
import {
  PaymentAcceptanceRules,
  PaymentInclusionExclusionPayload,
  PaymentInclusionExclusionRulesResponseV1,
  PaymentRemittanceRulesApiResponse,
  PreAuthorizedDebitModeV1Response,
} from '../models';
import { PaymentAcceptanceRulesService } from './payment-acceptance-rules.service';

export class PaymentAcceptanceRulesGuestCheckoutService extends PaymentAcceptanceRulesService {
  constructor(
    private httpClient: HttpClient,
    protected appConfig: AppConfigSettings,
  ) {
    super(appConfig);
  }

  getPaymentAcceptanceRulesV1(
    tenantId: string,
    originApplication: string,
    cardMarsToken: string,
  ): Observable<PaymentAcceptanceRules> {
    return this.httpClient.post<PaymentAcceptanceRules>(
      `${this.baseUrl}/v1/tenants/${tenantId}/paymentsettings-hosted-payments-anonymous`,
      {
        originApplication,
        cardMarsToken,
      },
    );
  }

  getCardInclusionExclusionListV1(
    payload: PaymentInclusionExclusionPayload,
  ): Observable<PaymentInclusionExclusionRulesResponseV1> {
    const buyerAccounts = payload.buyerAccounts;
    return this.httpClient.post<PaymentInclusionExclusionRulesResponseV1>(
      `${this.baseUrl}/v1/tenants/${payload.tenantId}/paymentsettings-hosted-payments-anonymous/card/buyeraccounts`,
      {
        buyerAccounts,
      },
    );
  }

  getPaymentRemittanceRulesV1(): Observable<PaymentRemittanceRulesApiResponse> {
    return of();
  }

  getPreAuthorizedDebitModeV1(
    tenantId: string,
  ): Observable<PreAuthorizedDebitModeV1Response> {
    return this.httpClient.get<PreAuthorizedDebitModeV1Response>(
      `${this.baseUrl}/v1/tenants/${tenantId}/pre-authorized-debit/mode-hosted-payments-anonymous`,
    );
  }
}
